<div class="add-role-dialog">
  <app-close-button
    [hasChanges]="hasChanges()"
    (closed)="sharedUI.closeDialog(dialogRef)"
    (confirmClosed)="showConfirmationDialog()"
  ></app-close-button>
  <form
    [formGroup]="form"
    (ngSubmit)="store.submitRole(form, dialogRef)"
    class="add-role-dialog__form"
  >
    <div class="add-role-dialog__header">
      <div class="add-role-dialog__icon-wrapper">
        <mat-icon
          [style.color]="form.controls.icon.controls.color.value"
          [style.backgroundColor]="form.controls.icon.controls.background.value"
          class="add-role-dialog__icon"
          >{{ store.platformIcon() }}</mat-icon
        >
        @if (!showColorPicker()) {
        <mat-icon
          (click)="toggleColorPicker()"
          (keydown.enter)="toggleColorPicker()"
          tabindex="-1"
          role="button"
          class="add-role-dialog__color-toggle"
        >
          format_color_fill
        </mat-icon>
        } @if (showColorPicker()) {
        <app-color-picker
          [icon]="store.platformIcon()"
          [previousColor]="form.controls.icon.getRawValue()"
          (colorSelected)="onColorSelected($event)"
          class="add-role-dialog__color-picker"
        ></app-color-picker>
        }
      </div>
      <app-editable-field
        formControlName="name"
        [control]="form.controls.name"
        [placeholder]="('roleName' | translate | async)!"
        [overrides]="[
          'title',
          'card-title',
          'no-subscript-wrapper',
          'no-error'
        ]"
        class="add-role-dialog__name-field"
      ></app-editable-field>
      <app-editable-field
        formControlName="description"
        [control]="form.controls.description"
        [placeholder]="('editableFieldOptionalDescription' | translate | async)!"
        [overrides]="['title', 'card-subtitle', 'no-subscript-wrapper']"
        class="add-role-dialog__description-field"
      ></app-editable-field>
    </div>
    <mat-dialog-content class="add-role-dialog__content">
      <mat-tab-group [selectedIndex]="selectedTabIndex" fitInkBarToContent>
        <mat-tab [label]="('permissions' | translate | async)!">
          <app-permissions
            class="add-role-dialog__permissions"
          ></app-permissions>
        </mat-tab>
        @let assignedUsers = store.tempRole()?.assignedUsers?.length || 0;
        <mat-tab [label]="('users' | translate | async) + ' '+ '(' + assignedUsers + ')'">
          <app-role-users
            [roleName]="form.controls.name.value"
            [icon]="form.controls.icon.getRawValue()"
            [addDisabled]="!form.controls.name.value"
            class="add-role-dialog__users"
          ></app-role-users>
        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions class="add-role-dialog__actions" align="end">
      <button
        mat-stroked-button
        type="button"
        [disabled]="!hasChanges()"
        (click)="showConfirmationDialog()"
      >
        {{'cancel' | translate | async}}
      </button>
      <button mat-flat-button type="submit" [disabled]="!hasChanges()">
        {{'save' | translate | async}}
      </button>
    </mat-dialog-actions>
  </form>
</div>
